/* lua.js generated code 0.3.1 */

require("clover/gamePlay/CreateGameSceneLogic")
let StartTimeBlockLevelLogic = xClass("StartTimeBlockLevelLogic")
const SETTING_OPEN_FLAGNAME = "timeMatchOpen";

//font/zzgftongxin_70_greenstroke.fnt
StartTimeBlockLevelLogic.checkCanStart = function () {
    let info = TimeModeActivityManager.getInstance().getInfo()

    // let local = Localhost.time()
    // let activityEnd = local >= info.end
    
    var activityEnd = !UserManager.getInstance().settings.data[SETTING_OPEN_FLAGNAME];

    if (activityEnd) {
        return [null, ZooErrorCode.TIME_MODE_ACTIVITY_END]
    }
    let hasTimes = info.leftTimes > 0
    if (!hasTimes) {
        return [null, ZooErrorCode.TIME_MODE_TIME_NOT_ENOUGT]
    }
    return [true]
}
StartTimeBlockLevelLogic.create = function (levelId) {
    let self = this
    let [success, errCode] = self.checkCanStart(levelId)
    if (!success) {
        return [null, errCode]
    }
    return [StartTimeBlockLevelLogic.new(levelId)]
}
StartTimeBlockLevelLogic.prototype.ctor = function (levelId) {
    let self = this
    self.levelId = levelId
    self.initProps = table()
    self.isBusy = false
    self.waitingPanelAnim = false
    self.successCallback = null
    self.failCallback = null
}
StartTimeBlockLevelLogic.prototype.initLevelLogics = function () {
    require.ensure([], () => {
        require("clover/scene/GameScene")
        require("clover/scene/GameSceneUI")
        FailLevelLogicClassTypeRef[GameLevelType.kTimeBlockCollection] = require("activity/TimeModeActivity/startEndLevelLogic/FailTimeBlockLevelLogic")
        PassLevelLogicClassTypeRef[GameLevelType.kTimeBlockCollection] = require("activity/TimeModeActivity/startEndLevelLogic/PassTimeBlockLevelLogic")
        QuitLevelLogicClassTypeRef[GameLevelType.kTimeBlockCollection] = require("activity/TimeModeActivity/startEndLevelLogic/QuitTimeBlockLevelLogic")
    }, null, 'game')
}
StartTimeBlockLevelLogic.prototype.start = function (onSuccess, onFail) {
    let self = this
    // self.initLevelLogics()
    self.successCallback = onSuccess
    self.failCallback = onFail
    self.startLevel()
}
StartTimeBlockLevelLogic.prototype.levelInfo = function () {
    let self = this
    let ret = table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
    let levelType = LevelType.getLevelTypeByLevelId(self.levelId)
    ret.levelType = levelType
    ret.levelId = self.levelId
    return ret
}
StartTimeBlockLevelLogic.prototype.startLevelReplay = function(replay, id, score) {
    let self = this
    var logic = CreateGameSceneLogic.create(self.levelId, table()) //selectedItemsData
    logic.startReplayGamePlayScene(replay, id, score, function() {
        self.initLevelLogics()
    })
}
StartTimeBlockLevelLogic.prototype.startLevel = function () {
    let self = this
    let context = this
    let instance = CreateGameSceneLogic.create(context.levelId, context.initProps)
    // let info = TimeModeActivityManager.getInstance().getInfo()
    function fail(event = {}) {
        Toast.make(curryQuickGetErrorText(event.data), 1, () => {
            let sceneName = cc.director._runningScene.name || cc.director._runningScene._name
            if (sceneName !== "HomeScene") {
                cc.Director.getInstance().popScene()
            }
            self.failCallback && self.failCallback()
        })
    }
    instance.startGamePlayScene(function (fileList) {
        function success() {
            // 成功之后扣除次数
            TimeModeActivityManager.getInstance().onStartLevel()
            self.successCallback && self.successCallback()
            context.initLevelLogics()
            instance.createGamePlayScene(fileList)
        }
        let retrytime = 2
        function onfail(event) {
            event.target.removeAllEventListeners()
            if (--retrytime > 0) {
                setTimeout(() => {
                    startLevel()
                }, 20);
            } else {
                fail(event)
            }
        }
        function startLevel() {
            // success()
            let http = TimeModeStartLevelHttp.new()
            http.addEventListener(Events.kComplete, success)
            http.addEventListener(Events.kError, onfail)
            http.load()
        }
        startLevel()
    }, fail)
    UserLevel.getInstance().setCurrentLevel(null);
}
module.exports = StartTimeBlockLevelLogic
